import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, ButtonFilled, Image, Text, SvgIcon } from '../../../Base';

const WhiteButton = styled((props) => (
  <ButtonFilled
    variant={'default'}
    color={'white'}
    textColor={'text'}
    fontWeight={600}
    width={'100%'}
    maxWidth={595}
    {...props}
  />
))``;

const OfficialExamResult = ({
  onGoToNextSubsection,
  isLastSubsectionInCourse,
  onExitClassroom,
  onGoToSubsectionLanding,
}) => {
  return (
    <Flex
      flexDirection={'column'}
      bg={'primary'}
      px={6}
      pb={9}
      pt={9}
      alignItems={'center'}
      justifyContent={'space-around'}
      height={'100%'}
    >
      <Flex flexDirection={'column'} alignItems={'center'} width={'100%'}>
        <Image src={'/assets/images/quiz/circle-check-mark.svg'} width={'112px'} mb={4} />
        <Text textStyle={'heading4'} color={'white'} mb={7}>
          คุณทำข้อสอบเรียบร้อยแล้ว
        </Text>
      </Flex>
      <Flex flexDirection={'column'} alignItems={'center'} width={'100%'} mt={9}>
        <WhiteButton
          onClick={isLastSubsectionInCourse ? onGoToSubsectionLanding : onGoToNextSubsection}
          mb={4}
          width={['100%', '75%']}
        >
          <Flex alignItems={'center'} justifyContent={'center'}>
            {isLastSubsectionInCourse ? 'ดูผลสอบ' : 'เรียนบทต่อไป'}
            <SvgIcon icon={SvgIcon.ICON_LIST.NEXT} size={24} />
          </Flex>
        </WhiteButton>
        <WhiteButton onClick={onExitClassroom} width={['100%', '75%']}>
          กลับสู่หน้าคอร์สของฉัน
        </WhiteButton>
      </Flex>
    </Flex>
  );
};

OfficialExamResult.propTypes = {
  onExitClassroom: PropTypes.func,
  onGoToNextSubsection: PropTypes.func,
  onGoToSubsectionLanding: PropTypes.func,
  isLastSubsectionInCourse: PropTypes.bool,
};

export default OfficialExamResult;
